import classNames from "utils/class-names";
import { FILTER_TYPE } from "utils/constants";

export const stripHtml = (html) => html.replace(/<\/?[^>]+(>|$)/g, "");

export const COLUMNS_DATA = ({
  deleteRow,
  editTermsCondition,
  isSuperFranchise,
  isFranchiseEmployee,
  isSubFranchise,
  filters, }) => [
    {
      Header: "S.No",
      accessor: "_index",
      disableSortBy: true,
    },
    {
      Header: "Id",
      accessor: "id",
      disableSortBy: true,
    },
    {
      Header: "Title",
      accessor: "title",
      disableSortBy: true,
    },
    {
      Header: "Terms and Condition",
      accessor: "terms_and_condition",
      disableSortBy: true,
      Cell: ({ value }) => stripHtml(value),
    },
    {
      Header: "",
      accessor: "ids",
      disableSortBy: true,
      Cell: ({ cell }) => {
        return (
          <>
            <button
              disabled={!filters.is_active}
              className={classNames("btn dropdown-toggle", {
                "btn-primary": filters.is_active,
                "btn-secondary": !filters.is_active,
              })}
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              More...
            </button>
            <ul className="dropdown-menu">
              <li>
                <button
                  className="dropdown-item"
                  onClick={() => editTermsCondition(cell.row.original)}
                >
                  Edit
                </button>
              </li>

              {(isSuperFranchise != 1 && isFranchiseEmployee != 1 && isSubFranchise != 1) && <li>
                <button
                  className="dropdown-item"
                  onClick={() => deleteRow(cell.row.original)}
                >
                  Delete
                </button>
              </li>}
              <li>
                <button className="dropdown-item">Something else here</button>
              </li>
            </ul>
          </>
        );
      },
    },
  ];

export const TERMSCONDITION_FORM_CONFIG = (rowData) => [
  {
    label: "Title",
    type: "input-text",
    name: "title",
    defaultValue: rowData?.title || "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Terms and Condition",
    type: "text-area",
    name: "terms_and_condition",
    defaultValue: rowData?.terms_and_condition || "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
];

export const OPTIONS = [
  { key: "title", value: "Title" },
  { key: "terms_and_condition", value: "Terms and Condition" },
];

export const STATUS_OPTIONS = [
  { key: true, value: "Active" },
  { key: false, value: "In-Active" },
];

export const FILTER_DEFINATIONS = [
  {
    name: "keyword",
    type: FILTER_TYPE.SELECT,
    initialValue: OPTIONS[0].key,
  },
  {
    name: "text",
    type: FILTER_TYPE.TEXT,
    initialValue: "",
    debounce: true,
  },
  {
    name: "is_active",
    type: FILTER_TYPE.SELECT,
    initialValue: STATUS_OPTIONS[0].key,
  },
];
